import { render } from "./CreatorSignupHeroVer3.vue?vue&type=template&id=7143afde&scoped=true"
import script from "./CreatorSignupHeroVer3.vue?vue&type=script&lang=js"
export * from "./CreatorSignupHeroVer3.vue?vue&type=script&lang=js"

import "./CreatorSignupHeroVer3.vue?vue&type=style&index=0&id=7143afde&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7143afde"]])

export default __exports__